var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"mt-5"},[_c('b-col',[_c('lunch-ticket-search',{staticClass:"mb-2"}),_c('lunch-ticket-table')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }